"use strict";import{IconEditExclude as e}from"../src/elements/IconEditExclude.js";import{defineElement as c}from"@spectrum-web-components/base/src/define-element.js";c("sp-icon-edit-exclude",e);
//# sourceMappingURL=sp-icon-edit-exclude.js.map
